import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "../../../components/Spinner/Spinner"
import * as actions from "../../../store/actions/index";
import StaffsCard from "./staffsCard";

class AddStaff extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleAddStaff = this.handleAddStaff.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleToggleStaffStatus = this.handleToggleStaffStatus.bind(this);
    this.handleDeleteStaff = this.handleDeleteStaff.bind(this);

    this.state = {
      staffName: "",
      staffEmail: "",
      staffContact: "",
      staffAddress: "",
      admin: false,
      staffId: null,
      staffs: null,
    };
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }
  componentDidMount() {
    this.props.onFetchStaff().then();
  }

  componentDidUpdate() {
    if (this.props.staffs && !this.state.staffs) {
      this.setState({ staffs: this.props.staffs });
    }
  }

  handleAddStaff(e) {
    e.preventDefault();
    let newStaff = {
      staffName: this.state.staffName,
      staffEmail: this.state.staffEmail,
      staffContact: this.state.staffContact,
      staffAddress: this.state.staffAddress,
      admin: this.state.admin,
    };
    this.props.onAddStaff(newStaff);
  }

  handleStaffEdit = (e, staffId) => {
    let { name, value } = e.target;
    let staffs = this.state.staffs.concat();
    let staff = staffs.filter((obj) => obj.staffId === staffId)[0];
    if (name == "admin") {
      staff[name] = value == "true" ? true : false;
    } else {
      staff[name] = value;
    }
    
    this.setState({ staffs });
  };

  handleEditSubmit(e) {
    e.preventDefault();
    let staffId = this.state.staffId;
    if (!staffId) {
      return alert("staffId is null");
    }
    let staff = this.state.staffs.filter(
      (staffObj) => staffObj.staffId == staffId
    )[0];
    this.props.onEditStaff(staff);
    // let staffs = this.state.staffs;
    // if (staffs) {
    //   this.props.onEditStaff(staffs);
    // } else {
    //   alert("Staffs is null.");
    // }
  }

  handleToggleStaffStatus(e, staffId, status) {
    e.preventDefault();
    this.props.onToggleStaffStatus(staffId, status);
  }

  handleDeleteStaff(e, staffId) {
    e.preventDefault();
    this.props.onDeleteStaff(staffId);
  }

  render() {
    let staffs = this.state.staffs;
    let staffList =
      staffs &&
      staffs.map((staff, index) => (
        <StaffsCard
          key={index}
          staffId={staff.staffId}
          staffName={staff.staffName}
          staffEmail={staff.staffEmail}
          staffContact={staff.staffContact}
          staffAddress={staff.staffAddress}
          status={staff.status}
          admin={staff.admin}
          handleChange={this.handleStaffEdit}
          handleEditSubmit={this.handleEditSubmit}
          handleToggleStaffStatus={this.handleToggleStaffStatus}
          handleDeleteStaff={this.handleDeleteStaff}
          editStaffLoading={this.props.editStaffLoading}
          toggleStaffStatusBtnLoading={this.props.toggleStaffStatusBtnLoading}
          deleteStaffBtnLoading={this.props.deleteStaffBtnLoading}
          setStaffOnEdit={() => this.setState({ staffId: staff.staffId })}
        />
      ));
    return (
      <div>
        <h3 className="text-center mt-2">Staff Management</h3>
        <hr />
        <form className="m-4" onSubmit={this.handleAddStaff}>
          <div className="form-row">
            <div className="form-group col-md-4">
              <label htmlFor="staffName">Name</label>
              <input
                type="text"
                name="staffName"
                className="form-control"
                id="staffName"
                placeholder="Name"
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="inputEmail4">Email</label>
              <input
                type="email"
                name="staffEmail"
                className="form-control"
                id="inputEmail4"
                placeholder="Email"
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="form-group col-md-3">
              <label htmlFor="staffContact">Phone No</label>
              <input
                type="number"
                name="staffContact"
                className="form-control"
                id="staffContact"
                onChange={this.handleChange}
                placeholder="Phone number"
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-8">
              <label htmlFor="inputAddress">Address</label>
              <textarea
                type="text"
                name="staffAddress"
                className="form-control"
                id="inputAddress"
                placeholder="1234 Main St"
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="mx-4">
              <legend className="col-form-label col-sm-1 mt-3">Admin</legend>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="admin"
                  id="inlineRadio1"
                  onChange={() => this.setState({ admin: true })}
                  value={true}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  Yes
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="admin"
                  onChange={() => this.setState({ admin: false })}
                  id="inlineRadio2"
                  value={false}
                />
                <label className="form-check-label" htmlFor="inlineRadio2">
                  No
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-success col-md-2"
              style={{
                marginTop: "45px",
                maxHeight: "45px",
                maxWidth: "fit-content",
              }}
              // onClick={this.handleAddStaff}
              disabled={this.props.addStaffLoading}
            >
              {this.props.addStaffLoading ? "Registering" : "Register Staff"}
            </button>
          </div>
        </form>
        <hr />
        {this.props.loading ? (
          <Spinner />
        ) : (
          <div className="row m-2">{staffList}</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    staffs: state.staffs.staffs,
    loading: state.staffs.loading,
    addStaffLoading: state.staffs.addStaffLoading,
    toggleStaffStatusBtnLoading: state.staffs.toggleStaffStatusBtnLoading,
    editStaffLoading: state.staffs.editStaffBtnLoading,
    deleteStaffBtnLoading: state.staffs.deleteStaffBtnLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchStaff: () => dispatch(actions.onFetchStaff()),
    onAddStaff: (newStaff) => dispatch(actions.onAddStaff(newStaff)),
    // onAddStaff:(newStaff)=>dispatch(actions.auth(true)),
    onEditStaff: (newStaff) => dispatch(actions.onEditStaff(newStaff)),
    onToggleStaffStatus: (staffId, status) =>
      dispatch(actions.onToggleStaffStatus(staffId, status)),
    onDeleteStaff: (staffId) => dispatch(actions.onDeleteStaff(staffId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddStaff);
